import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import { catchError, map, tap, takeLast } from 'rxjs/operators';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import Category from '../../models/Category';
import Product from '../../models/Product';
import Inventory from '../../models/Inventory';
import TemporaryPrice from '../../models/TemporaryPrice';
import ArrayList from '../../models/ArrayList';
import Partner from '../../models/PaymentMethod';
import ProcessStatus from '../../models/ProcessStatus';
import ProductHistory from '../../models/ProductHistory';
import { PreloaderService } from '../../common/services/preloader/preloader.service';
import Media from '../../models/Media';

@Injectable()
export class ProductService extends ServiceProvider {
  protected url = '/api/v1/admin/products';

  constructor() {
    super(AppInjector.get(HttpClient), AppInjector.get(ApiUrl), 'Product');
  }

  completeListing(id, data): Observable<any> {
    return this.http.post(`${this.apiUrl.getApiUrl(this.url)}/${id}/complete-listing`, data).pipe(
      map((result) => {
        return result;
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  updatePositionImage(id, data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.put(this.apiUrl.getApiUrl(this.url) + '/' + id + '/reorder-image', data).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new Product((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getProductLocationBySku(product_skus: String[] = []): Observable<any> {
    let params = { sku: product_skus.join(',') };
    return this.http.get(`${this.apiUrl.getApiUrl(this.url)}/location`, { params }).pipe(
      map((result) => (result as any).data.map((item) => new Inventory(item))),
      catchError((error) => {
        throw error;
      })
    );
  }
  clone(id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + id + '/clone', {}).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new Product((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
  reprocessImage(id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + id + '/reprocess-image', {}).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new Product((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  rotateImage(id, imageId): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + id + '/picture/' + imageId + '/rotate', {}).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new Media((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  deleteImage(id, imageId): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.delete(this.apiUrl.getApiUrl(this.url) + '/' + id + '/picture/' + imageId + '/delete').pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new Media((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getTemporaryPrices(id, filter = null, sort = []): Observable<any> {
    return this.http
      .get(this.apiUrl.getApiUrl(this.url) + '/' + id + '/temporary_price?' + (filter ? '&constraints=' + JSON.stringify(filter) : '') + (filter ? '&sort=' + sort.join(',') : ''))
      .pipe(
        tap((results) => {}),
        map((results) => {
          return _.assign(
            {},
            {
              data: new ArrayList<TemporaryPrice>(TemporaryPrice, (results as any).data)
            }
          );
        }),
        catchError((error) => {
          throw error;
        })
      );
  }

  getTemporaryPrice(data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(this.url + '/' + data.product_id + '/temporary_price/' + data.temporary_price_id), data).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new TemporaryPrice((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  createTemporaryPrice(data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url + '/' + data.product_id + '/temporary_price'), data).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new TemporaryPrice((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  editTemporaryPrice(data): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.put(this.apiUrl.getApiUrl(this.url + '/' + data.product_id + '/temporary_price/' + data.temporary_price_id), data).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => new TemporaryPrice((result as any).data)),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getHistories(id, type): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/' + id + '/' + type + '/' + 'histories').pipe(
      tap((results) => {}),
      map((results) => {
        return _.assign(
          {},
          {
            data: new ArrayList<ProductHistory>(ProductHistory, (results as any).data)
          }
        );
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getAllowedTransitions(id): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/' + id + '/process_status/transitions?').pipe(
      tap((results) => {}),
      map((results) => {
        return _.assign(
          {},
          {
            data: new ArrayList<ProcessStatus>(ProcessStatus, (results as any).data.allowed_transition.data)
          }
        );
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getCategories(id): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/' + id + '/category').pipe(
      tap((results) => {
        // console.log(results);
      }),
      map((results) => {
        return _.assign(
          {},
          {
            data: (results as any).data.map((item) => {
              return new Category(item);
            })
          }
        );
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getItemBySku(sku): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/sku/' + sku).pipe(
      map((result) => {
        return new Product((result as any).data);
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  reloadImage(path): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/syncImage', { path }).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }

  bulkUpdateProcessStatus({ sort, filter, search }, data): Observable<any> {
    let query = [];
    let sorts = [];
    if (sort) {
      for (const prop in sort) {
        if (sort[prop] !== null) {
          sorts.push(sort[prop] + prop);
        }
      }
    }
    AppInjector.get(PreloaderService).show();
    return this.http
      .put(
        this.apiUrl.getApiUrl(this.url) +
          '/bulk-update-process-status?' +
          (sort ? '&sort=' + _.join(sorts, ',') : '') +
          (filter ? '&constraints=' + JSON.stringify(filter) : '') +
          (search ? '&search=' + search : ''),
        { data }
      )
      .pipe(
        catchError((error) => {
          throw error;
        })
      );
  }
  getPartners(): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/partners').pipe(
      map((result) => {
        return new ArrayList<Partner>(Partner, (result as any).data);
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  sendPartnerQueue(data): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/partner-queue', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }
  createGhostProduct(data): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/ghost', data).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }
  printGhostProduct(code): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/ghost/' + code + '/print', {}).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }
  startGlobalSale(): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/startsale', {}).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }
  stopGlobalSale(): Observable<any> {
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/stopsale', {}).pipe(
      catchError((error) => {
        throw error;
      })
    );
  }
  importFromCsv(extraData, file): Observable<any> {
    const formdata: FormData = new FormData();
    formdata.append('file', file);
    Object.keys(extraData).forEach((key) => {
      formdata.append(key, extraData[key]);
    });
    return this.http
      .post(this.apiUrl.getApiUrl(this.url) + '/import/csv', formdata, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .pipe(
        catchError((error) => {
          throw error;
        })
      );
  }
  downloadAttributes(): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.get(this.apiUrl.getApiUrl(this.url) + '/export/attributes').pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => result),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  updateProductSold(id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/update-product-sold/' + id, {}).pipe(
      tap((result) => {
        AppInjector.get(PreloaderService).hide();
      }),
      map((result) => result),
      catchError((error) => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
}
